/**
 * SECTION Website scripts
 */

(function ($, root, undefined) {
	$(function () {
		// DOM ready, take it away

		/////////////////////////
		// DECLARATIONS VARIABLES COMMUNES
		var $menuPrincipal = $('.nav');



		/////////////////////////
		// LES FONCTIONS	
		function scrollToTop($delay) {
			if (!$delay) $delay = 0;
			$('html, body').stop(true, true).delay($delay).animate({ scrollTop: 0 }, 500, 'easeOutQuad'); // , 'easeOutQuad'
		};
		function scrollToContainer($delay) {
			if (!$delay) $delay = 0;
			var $destination = $(window).height(); //$('.fotorama').height()*1;
			$('html, body').stop(true, true).delay($delay).animate({ scrollTop: $destination }, 600, 'easeInOutQuad');
		}
		function scrollTo($theDiv, $delay, $decalage) {
			if (!$delay) $delay = 0;
			if (!$decalage) $decalage = 0;
			var offset = $($theDiv).offset().top;
			$('html, body').stop(true, true).delay($delay).animate({ scrollTop: (offset + $decalage) }, 600, 'easeInOutQuad');
			//console.log('t '+offset);
		};
		function string2Slug(str) {
			var $slug = '';
			var trimmed = $.trim(str);
			$slug = trimmed.replace(/[^a-z0-9-]/gi, '-').
				replace(/-+/g, '-').
				replace(/^-|-$/g, '');
			return $slug.toLowerCase();
		}
		function initScrolltoID($container) {
			if (!$container) var $container = $('html, body');
			else var $container = $($container);

			$('a[href^="#section-"]').on('click', function () { // Au clic sur un élément
				var page = $(this).attr('href'); // Page cible
				var speed = 1000; // Durée de l'animation (en ms)
				var decalage = 50;
				$container.animate({ scrollTop: ($(page).offset().top) - (decalage) }, speed, 'easeInOutQuad'); // Go
				return false;
			});
		}
		// Check if JS Object is empty
		function isEmpty(obj) {
			for (var key in obj) {
				if (obj.hasOwnProperty(key))
					return false;
			}
			return true;
		}

		// Read a page's GET URL variables and return them as an associative array.
		//		http://www.example.com/?me=myValue&name2=SomeOtherValue
		//		var me = getUrlVars()["me"];
		//		var name2 = getUrlVars()["name2"];
		function getUrlVars() {
			var vars = [], hash;
			var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');

			if (hashes !== window.location) {
				for (var i = 0; i < hashes.length; i++) {
					hash = hashes[i].split('=');
					vars.push(hash[0]);
					vars[hash[0]] = hash[1];
				}
				return vars;
			}
		}


		// Check if scrollBar // $('#my_div1').hasScrollBar(); // returns true if there's a `vertical` scrollbar, false otherwise..
		(function ($) {
			$.fn.hasScrollBar = function () {
				return this.get(0).scrollHeight > this.height();
			}
		})(jQuery);
		function checkBodyScrollBar() {
			if ($('body').hasScrollBar()) $('html').addClass('scrollbar');
			else { $('html').removeClass('scrollbar') }
		}


		//////////////////////////////////////////
		// Init Menu Principal
		function initMenu() {
			// BT language
			$('.header .language--content').click(function () {
				$('.header .language--content').toggleClass('open');
			})

			// BT Search // Affichage form search
			$('.header .search-button, .header .searchform--content .bt-close-form').click(function () {
				$('.header .searchform--content').toggleClass('open');
				$('.header .searchform--content input').val(''); //RAZ search Term
			})

			// Btn modifier la recherche
			$('.js-modify-search').click(function () {
				$('.header .searchform--content').toggleClass('open', true);
				$previousSearchTerm = $(this).data('search-term');
				$('.header .searchform--content input').val($previousSearchTerm);
				return false;
			})

			// Close nav menu if click on item nav
			$('.header .nav a').click(function () {
				$('.header .nav #toggle-nav').prop("checked", false).trigger("change");
			})
		} // end : initMenu()



		// INIT CONTENT
		function initContent() {
			//console.log('init content');
			// Apparition

			$('.show-frombottom:not(.swiper-container):not(.on-screen), .show-opacity:not(.grid-item-portrait):not(.gallery-item-masonry):not(.on-screen)').each(function (index) {
				var $element = $(this);

				setTimeout(function () {
					$element.addClass('open');
				}, (100 * index));
			});


			// onScreen // <div class="on-screen show-opacity"
			var os = new OnScreen({
				tolerance: 0,
				debounce: 100,
				container: window
			});
			// onScreen // Do something when an element enters the viewport
			os.on('enter', '.on-screen', (element, event) => {
				$(element).addClass('open');
			});

			// On error img
			$('img').on("error", function () {
				// $(this).attr('src', '/screenshot.png');
			});

			// Accordion Content ShortCode
			$('p.bt.accordion').click(function () {
				var $AccordionContent = $(this).prev('.accordion-content');
				var $AccordionContentH = $AccordionContent.height();
				var $currentPositionScroll = "";

				if ($AccordionContent.hasClass('open')) {
					$AccordionContent.slideUp('fast');
					$AccordionContent.removeClass('open');
					//$(this).find('a').attr('title', 'Lire la suite').html('Lire la suite');
					$(this).find('a span.icon-down').removeClass('icon-up');

					setTimeout(function () {
						scrollTo($AccordionContent, 200, -550);
						//console.log($currentPositionScroll);
						//$('html, body').stop(true, true).animate({scrollTop: $currentPositionScroll}, 600, 'easeInOutQuad');
					}, 300);
				}
				else {
					setTimeout(function () {
						initSwiper('gallery-wp'); // Init Galery WP Swiper car caché // BUG GARB CURSOR ??
					}, 800);

					$AccordionContent.slideDown('fast');
					$AccordionContent.addClass('open');
					//$(this).find('a').attr('title', 'Fermer').html('Fermer');
					$(this).find('a span.icon-down').addClass('icon-up');
					scrollTo($AccordionContent, 200, -250);
				}
				$currentPositionScroll = $(document).scrollTop();
			});

			// Scroll to ID with Hash
			initScrolltoID();

			// SIDEBAR STICKY-KIT
			if ($(window).width() > 768) {
				$('.sticky-col').stick_in_parent({ offset_top: 100, spacer: false })
			}

			// Initialisation PopUp Magnific PopUp
			initPopUp();

			// clean a span.btn--topophile
			$('a span.btn--topophile').parent().css({ 'background-image': 'none' });

			// Affiche liens calendrier
			$('.atcb-link').click(function () {
				$(this).next().slideToggle(300);
			})
		}; // initContent()	



		// INIT SOMMAIRE
		function initSommaire() {
			var wrapSommaire = $('.sidebar .wrapper-sommaire');
			var menuSommaire = wrapSommaire.find('.content-sommaire');

			// Création automatique du sommaire
			var sommaireContent = "";
			var nbItem = 0;
			if (wrapSommaire.length) {

				$('article h2:not(.no-summary)').each(function () {
					if (!$(this).is(':empty') && !$(this).text() == '' && !$(this).parent().hasClass('no-summary')) {// bug detection des div vide

						var itemTitle = $(this).text();
						var itemSlug = string2Slug(itemTitle);

						$(this).attr('id', 'section-' + itemSlug);
						sommaireContent += '<li><p><a href="#section-' + itemSlug + '" title="' + itemTitle + '">' + itemTitle + '</a></p></li>';
						nbItem++;

					}
				});

				// masque le sommaire si 1 seul item
				if (nbItem > 1 || $('ul.menu-sommaire li').length > 1) {
					// Apparition
					setTimeout(function () { wrapSommaire.addClass('open'); }, 550);

					menuSommaire.prepend(sommaireContent); // Ajout du contenu

					menuSommaire.singlePageNav({
						offset: 110,
						speed: 700,
						updateHash: true,
						threshold: 100,
						//easing:
						filter: ':not(.external)',
						currentClass: 'current-menu-item',
						beforeStart: function () {
							$('body').append('<div class="device-dummy" style="height: 1px;"></div>');
						},
						onComplete: function () {
							$('.device-dummy').remove();
						}
					});

					menuSommaire.find('a:not(.external)').click(function () {
						$This = $(this);
						if ($('.primary-content .accordion-content').length && !$('.primary-content .accordion-content').hasClass('open')) {
							$('p.bt.accordion').trigger('click'); // on ouvre le content accordion !! scroll automatique 

							// On reclick sur le sommaire evite le scroll automatique du contentn accordion
							setTimeout(function () {
								$This.trigger('click');
							}, 200)
						}
						return false;
					})

				}
				else {
					//$menuSommaire.remove();
				}
			}

		} // initSommaire()



		//  INIT FOOTER
		function initFooter() {
			/// On Windows Scroll
			$(window).scroll(function () {
				var scrollTop = $(window).scrollTop();
				var stickyTop = $('.header').offset().top;
				var menuTop = $('.header');

				if (scrollTop > 100) {
					$('.footer .bt-up').addClass('open')
				}
				else {
					$('.footer .bt-up').removeClass('open');
				}
			});

			// Bt UP to top
			$('.footer .bt-up').click(function () {
				setTimeout(function () {
					$("html, body").animate({ scrollTop: 0 }, 500, 'easeInOutQuad', function () {
					});
				}, 100);
				return false;
			});

			$('.footer .bt-share').click(function () {
				$(this).find('.popup-profil').toggleClass('open');
			});

		} // initFooter()



		//  INIT PopUp Magnific PopUp // initContentPage()
		function initPopUp(e) {

			// Suppression a img
			$('a img').parent().addClass('no-border');

			$('.gallery ').magnificPopup({
				delegate: 'a:not(.custom-link)',
				type: 'image',
				tLoading: '...',
				preloader: true,
				mainClass: 'mfp-fade', // this class is for CSS animation below
				removalDelay: 500,
				closeMarkup: '<button title="%title%" class="mfp-close"></button>',
				closeOnBgClick: false,
				gallery: {
					enabled: true,
					navigateByImgClick: true,
					preload: [0, 2], // Will preload 0 - before current, and 1 after the current image
					tCounter: '<span class="mfp-counter"><b>%curr%</b> / %total%</span>' // markup of counter
				},
				image: {
					titleSrc: function (item) {
						return item.el.find('img').attr('alt');
						// return item.el.parent().find('.gallery-caption').text(); //  
					},
					verticalFit: true, // Fits image in area vertically
					tError: '<p style="color:#000"><a href="%url%" style="color:#000">L’image #%curr%</a> ne peut-être chargée. </p><button title="%title%" class="mfp-close" style="left: -300px;  top: -50px;"></button>'
				},
				autoFocusLast: true,
				overflowY: 'hidden',
				fixedContentPos: false,
				callbacks: {
					beforeOpen: function () {
						setTimeout(function () {
							$('body').addClass('noscroll');
						}, 200);
					},
					beforeClose: function () {
						jQuery('body').removeClass('noscroll');
					},
					open: function () {
						$.magnificPopup.instance.next = function () {
							var self = this;
							self.wrap.removeClass('mfp-image-loaded');
							setTimeout(function () {
								$.magnificPopup.proto.next.call(self);
							}, 120);
						}
						$.magnificPopup.instance.prev = function () {
							var self = this;
							self.wrap.removeClass('mfp-image-loaded');
							setTimeout(function () {
								$.magnificPopup.proto.prev.call(self);
							}, 120);
						}
					},
					imageLoadComplete: function () {
						var self = this;
						setTimeout(function () {
							self.wrap.addClass('mfp-image-loaded');
						}, 16);
					}
				}

			});

			//single image popup
			$('a[href*=".jpg"], a[href*=".jpeg"], a[href*=".png"], a[href*=".gif"]').each(function () {
				if ($(this).parents('.gallery').length == 0) { // si pas de gallery
					$(this).magnificPopup({
						type: 'image',
						tLoading: '...',
						preloader: false,
						mainClass: 'mfp-fade', // this class is for CSS animation below
						removalDelay: 500,
						closeMarkup: '<button title="%title%" class="mfp-close"></button>',
						closeOnBgClick: true,
						image: {
							titleSrc: function (item) {
								//console.log(item.el.next().text());
								return item.el.next().text(); //.find('.wp-caption-text')

								// return item.el.parent().find('.gallery-caption').text(); //  
							},
							verticalFit: true, // Fits image in area vertically
							//tError: '<p style="color:#000"><a href="%url%" style="color:#000">L’image #%curr%</a> ne peut-être chargée. </p><button title="%title%" class="mfp-close" style="left: -300px;  top: -50px;"></button>'
							tError: '<p style="color:#000"><a href="%url%" style="color:#000">L’image #%curr%</a> ne peut-être chargée. </p><button title="%title%" class="mfp-close" style="left: -300px;  top: -50px;"></button>'
						},
						autoFocusLast: true,
						overflowY: 'hidden',
						fixedContentPos: false,
						callbacks: {
							beforeOpen: function () {
								setTimeout(function () {
									$('body').addClass('noscroll');
								}, 200);
							},
							beforeClose: function () {
								jQuery('body').removeClass('noscroll');
							}
						}
					});
				}
			});

			//console.log('init PopUp');
		} // end initPopUp()


		// INIT SWIPER HOME
		function initSwiper() {
			$autoPlay = $('.swiper-container').data('autoplay');
			if ($autoPlay == 0 || !$autoPlay) $autoPlay = 1000000; // false ne marche pas…

			$autoHeight = $('.swiper-container').data('autoheight');
			if ($autoHeight == 0 || !$autoHeight) $autoHeight = false; // false ne marche pas…

			$swiperContainer = $('.swiper-container');
			$swiperEffect = 'fade';
			$slidesPerView = 1; //'auto';

			var mySwiper = new Swiper($swiperContainer, {
				// Optional parameters
				observer: true, //Set to true to enable Mutation Observer on Swiper and its elements. 
				observeParents: true, // Set to true if you also need to watch Mutations for Swiper parent elements
				preloadImages: false, // Disable preloading of all images
				slidesPerView: $slidesPerView,
				loop: $swiperContainer.find('.swiper-slide').length > 2 ? true : false, // bug decalage petit écran

				simulateTouch: false,
				watchSlidesVisibility: true,
				lazy: {
					loadPrevNext: true,
					loadPrevNextAmount: 1
				},


				grabCursor: true,
				resistance: false,
				preventInteractionOnTransition: true,
				// AutoPlay
				autoplay: {
					delay: $autoPlay,
				},
				effect: $swiperEffect,
				speed: 500,
				watchSlidesProgress: true, // should be enabled
				watchVisibility: true, // additional visible class

				keyboard: true,
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},

				autoHeight: $autoHeight, //enable auto height
				breakpoints: {
					// when window width is <= 640px
					576: { // small
						// autoHeight: true, //enable auto height
					}
				},

				on: {
					lazyImageReady: function () {
						//console.log('lazyImageReady');
						setTimeout(function () {
							$swiperContainer.addClass('open');
						}, 100);
						//checkSwiperPagination($swiperContainer); 
					},
					resize: function () {
						setTimeout(function () {
							swiperUpdate();
						}, 500);
					},
					init: function () {
						//swiperUpdate();
					}
				}
			})

			function swiperUpdate() {
				var mySwiper = $('.swiper-container')[0].swiper;

				$autoHeight = $('.swiper-container').data('autoheight');
				if ($autoHeight == 0 || !$autoHeight) $autoHeight = false; // false ne marche pas…
				mySwiper.params.autoHeight = $autoHeight;
			}


		} // initSwiperHome()



		// MASONRY GRID
		function initMasonry() {
			$grid = $('.grid-masonry');

			$grid.imagesLoaded().progress(function (instance, image) {
				$grid = $('.grid-masonry').masonry({
					itemSelector: '.grid-item',
					columnWidth: '.grid-item',
					percentPosition: true,
					transitionDuration: 000
				});
				$grid.masonry('reloadItems'); // Recollects all item elements.

				$Index = $(image.img).parent().parent().parent().index();
				setTimeout(function () {
					$(image.img).parent().parent().parent().addClass('open'); // Visible
				}, $Index * 150)

			});
			$('.grid-item.no-thumbnail').each(function (index) {
				var $element = $(this);

				setTimeout(function () {
					$element.addClass('open');
				}, (100 * index));

			});

			// console.log("initMasonry()");
			$(window).resize(function () {
				setTimeout(function () {
					$grid.masonry('layout');
				}, 600);
			});
		} // initMasonry()


		// searchandfilterEvent()
		function searchandfilterEvent() {
			$(document).on("sf:ajaxfinish", ".searchandfilter", function (newElements, div) {
				// console.log("ajax Finish");
				//initMasonry();
				initContent();
				initMenuTaxonomy();

				// Scroll vers container depuis l'interface admin (modif top -65px)
			});
			$(document).on("sf:ajaxstart", ".searchandfilter", function (newElements, div) {
				//console.log("ajax Finish"+newElements);
			});
			//an event fired when S&F is initialised and S&F scripts have been loaded
			$(document).on("sf:init", ".searchandfilter", function () {
				// console.log("S&F JS initialised");initMenuTaxonomy();

				var searchQuery = getUrlVars(); // function getUrlVars
				if (searchQuery[0].startsWith('_')) { // check if Vars Search and Filters
					scrollTo($('.ajax-container'), 0, -105);
				}
			});
		} // searchandfilterEvent()



		// initMenuTaxonomy() Search and Filter Init
		function initMenuTaxonomy() {
			// Disable TaxonomyMenu if empty
			$('.searchandfilter > ul > li > ul:not(:has(li))').each(function () {
				$(this).parent().find('h4').addClass('disable');
			})

			// Selection Menu taxonomie FAIRE si variable dans URL
			var searchQuery = getUrlVars(); // function getUrlVars
			if (searchQuery) {
				$.each(searchQuery, function (index, value) {
					$(".searchandfilter > ul > li[data-sf-field-name='" + value + "']").addClass('selected');

					// pour Faire on masque le contenu ul
					$("#search-filter-form-221 > ul > li[data-sf-field-name='" + value + "']").find('ul').hide();
				})
			}


			// Ouverture du menu Taxonomie si variable dans URL
			// add selected class to h4 when 
			var searchQuery = getUrlVars(); // function getUrlVars
			if (searchQuery) {
				$.each(searchQuery, function (index, value) {
					$(".searchandfilter > ul > li[data-sf-field-name='" + value + "']").addClass('selected').find('ul').show();
				})
			}
			else {
				$('.search-filter-custom-date-range ul li ul').hide();
			}

			// Action on click sur H4
			$('.searchandfilter > ul > li > h4:not(.disable)').off().click(function () {
				if ($(this).parent().hasClass('is-open')) { // replie si ouvert
					var itemMenu = $('.searchandfilter > ul > li');
					itemMenu.find('ul').slideUp('fast');
				}
				else {
					$(this).next().slideToggle('fast');
				}
				$(this).parent().toggleClass('is-open');
			})


		} // initMenuTaxonomy()





		//////////////////////////////////////////
		/// BREAKPOINT CSS TO JS
		// extra-large : 1200px || large : 992px || medium : 768px || small : 576px || tiny : 480px
		var breakpoint = {};
		breakpoint.refreshValue = function () {
			this.value = window.getComputedStyle(
				document.querySelector('body'), ':before'
			).getPropertyValue('content').replace(/\"/g, '');
		};
		$(window).resize(function () {
			breakpoint.refreshValue();
			// console.log(breakpoint.value);
		}).resize();
		breakpoint.refreshValue();


		/////////////////////////
		// INIT
		// dissable drag Image
		$('img').mousedown(function (e) {
			e.preventDefault();
			return false;
		});
		// dissable right click
		//		$(this).bind("contextmenu", function(e) {
		//            e.preventDefault();
		//            return false;
		//        });


		// INIT SCRIPT
		checkBodyScrollBar();
		initMenu();
		initContent();
		initFooter();

		// IF HOME
		if ($('body').hasClass('home')) {
			initSwiper();
			initMasonry();
		}
		else if ($('body').hasClass('page')) {
			initSommaire();
		}
		else if ($('body').hasClass('post-type-archive-savoir')) {
			initSwiper();
			searchandfilterEvent();
			initMenuTaxonomy();
		}
		else if ($('body').hasClass('post-type-archive-faire')) {
			searchandfilterEvent();
			initMenuTaxonomy();
		}
		else if ($('body').hasClass('post-type-archive-auteur')) {
			searchandfilterEvent();
			initMenuTaxonomy();
		}
		else if ($('body').hasClass('post-type-archive-evenement')) {
			searchandfilterEvent();
			initMenuTaxonomy();
		}
		else if ($('body').hasClass('single')) {
			initSommaire();
			//console.log('single');
		}


		///////////////////// on RESIZE WINDOWS
		$(window).resize(function () {
			checkBodyScrollBar();
		});


	});
})(jQuery, this);
